var map = {
	"./PC1.png": "0ba8",
	"./PC10.png": "d8e3",
	"./PC11.png": "ec94",
	"./PC12.png": "369b",
	"./PC2.png": "9127",
	"./PC3.png": "e81c",
	"./PC4.png": "27ab",
	"./PC5.png": "cef8",
	"./PC6.png": "e572",
	"./PC7.png": "f7ca",
	"./PC8.png": "f90f",
	"./PC9.png": "5eb8",
	"./attention.png": "7c44",
	"./attentioned.png": "f746",
	"./banner.jpg": "b5bb",
	"./pause.png": "5376",
	"./play.png": "c5c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57bb";